import { GET_RECOMMENDED_DOCTORS_LIST } from "@/components/graphql/doctors";
import { fetchDoctorsVariables } from "@/components/graphql/types/getDoctorsList";
import { API_GRAPHQL_FETCH_DOCTOR_API } from "@/libs/constants/logger";
import { FetchDoctorsPayload } from "@/redux/slice/doctors/types/FetchDoctorsPayload";

export default async function fetchDoctorsApi(fetchCartPayload: FetchDoctorsPayload) {
  const { specialtyId, apolloClient, apolloLogger, correlationId, pageUrl } = fetchCartPayload;
  let doctorsData = null;

  try {
    const response = await apolloClient.query<any, fetchDoctorsVariables>({
      query: GET_RECOMMENDED_DOCTORS_LIST,
      variables: {
        filterInput: {
          pageNo: 1,
          pageSize: 5,
          specialty: specialtyId,
        },
      },
      fetchPolicy: "no-cache",
    });
    apolloLogger?.info({
      event: API_GRAPHQL_FETCH_DOCTOR_API,
      message: `Doctors list api success with specialtyId ${specialtyId}`,
      correlationId: correlationId,
      identifier: pageUrl,
    });
    doctorsData = response;
  } catch (err) {
    console.log(err);
    apolloLogger?.error({
      event: API_GRAPHQL_FETCH_DOCTOR_API,
      error: err,
      type: err,
      message: `Doctors list api success with specialtyId ${specialtyId}`,
      correlationId: correlationId,
      identifier: pageUrl,
    });
  }

  return doctorsData;
}
